/**
 * リンクリストを表示するコンポーネント
 */

import { HashLink } from "react-router-hash-link";

/**
 * リンクアイテムの型
 * @property {string} to - リンク先のURL
 * @property {string} text - リンクテキスト
 */
interface LinkItem {
  to: string;
  text: string;
}

/**
 * リンクリストのプロパティ
 */
interface LinkListProps {
  items: LinkItem[];
}

/**
 * リンクリストコンポーネント
 * @param {LinkListProps} props - リンクリストのプロパティ
 * @returns {JSX.Element} リンクリストのJSX要素
 */
const LinkList: React.FC<LinkListProps> = ({ items }) => {
  return (
    <ul className="c-link-list">
      {items.map((item, index) => (
        <li key={index}>
          <HashLink to={item.to} className="c-angle">
            {item.text}
          </HashLink>
        </li>
      ))}
    </ul>
  );
};

export default LinkList;
